import * as React from 'react';

import PlatformPage from '../../components/layout/Content/PlatformPage';

const ReactComponents: React.FunctionComponent = () => {
  const title = 'Unifi React';
  const slug = '/react/components/';
  const intro = 'View demos and learn about using available Unifi React components.';

  return <PlatformPage {...{ title, slug, intro, platform: 'react' }} />;
};

export default ReactComponents;
